// Single source of truth for the owned application build label.
// Vite injects the current commit count and build channel, so every
// integrated commit produces a visibly different footer without manual edits.
const injectedVersion = globalThis.__SCTMG_APP_VERSION__;
export const APP_VERSION = injectedVersion || '0.1.0-pro';
